import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router";
import { AuthContext } from "./Auth";
import { usePremiumStatus } from "../contexts/PremiumContext";

const PremiumRoute = ({ children }: { children: React.ReactNode }) => {
  const context = useContext(AuthContext);
  const location = useLocation();
  const { isPremium, status } = usePremiumStatus();

  if (!context?.currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (status === "loading") {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Checking subscription status...</p>
      </div>
    );
  }

  if (!isPremium) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-bold mb-4">Premium Feature</h2>
        <p className="text-muted-foreground">
          This feature is available to premium subscribers.
        </p>
      </div>
    );
  }

  return children;
};

export default PremiumRoute;
